import { PrintProps } from './equation-response.constants';
import * as Styled from './equation-response-print.style';
import { getOperatorSymbol } from './equation-response.utils';
import { COMPONENT_LAYOUT_HORIZONTAL } from 'global/constants';
import { EquationResponseHr } from './equation-response.style';
import SubActivityPrint from '../sub-activity/sub-activity-print';

const EquationResponsePrint = ({
  properties,
  subActivityProperties,
}: PrintProps) => {
  const isHorizontal =
    properties.layout?.orientation === COMPONENT_LAYOUT_HORIZONTAL;

  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      <Styled.EquationResponse $vertical={!isHorizontal}>
        {isHorizontal ? (
          <>
            <Styled.EquationResponseBox>
              {properties.firstOperand}
            </Styled.EquationResponseBox>

            <Styled.EquationResponseOperator>
              {getOperatorSymbol(properties.operation)}
            </Styled.EquationResponseOperator>

            <Styled.EquationResponseBox>
              {properties.secondOperand}
            </Styled.EquationResponseBox>

            <Styled.EquationResponseOperator>=</Styled.EquationResponseOperator>

            <Styled.EquationResponseAnswer />
          </>
        ) : (
          <>
            <Styled.EquationResponseBoxVertical>
              {properties.firstOperand}
            </Styled.EquationResponseBoxVertical>

            <Styled.EquationResponseOperatorWrapper>
              <Styled.EquationResponseOperator>
                {getOperatorSymbol(properties.operation)}
              </Styled.EquationResponseOperator>
              <Styled.EquationResponseBoxVertical>
                {properties.secondOperand}
              </Styled.EquationResponseBoxVertical>
            </Styled.EquationResponseOperatorWrapper>

            <EquationResponseHr />

            <Styled.EquationResponseAnswerVertical />
          </>
        )}
      </Styled.EquationResponse>
    </SubActivityPrint>
  );
};

export default EquationResponsePrint;
